import { Link } from 'react-router-dom'
import { PhoneCall, Ticket, ChevronRight } from 'lucide-react'
import { Page, PageHeader } from '../kit'

// ติดตาม (follow-up) landing — two tools. Recall = the patient recall/call-back
// worklist. Ticket = job/issue tracker (list + create/edit drawer + follow-up thread).
const TOOLS = [
  {
    to: '/follow-ups/recall',
    icon: PhoneCall,
    title: 'Recall',
    desc: 'รายชื่อคนไข้ที่ต้องติดตาม/โทรกลับ · แยกตามประเภท (Normal · Top Spender · High Billing · เบิกย้อนหลัง · Error) · ดูประวัติ recall นัดหมาย และการรักษา',
  },
  {
    to: '/follow-ups/ticket',
    icon: Ticket,
    title: 'Ticket',
    desc: 'ติดตามงาน/เรื่องที่ต้องดำเนินการ · แยกตามสถานะ (ยังไม่เสร็จ/เสร็จแล้ว) · ผูกกับคนไข้/แท็ก · เพิ่มโน้ตติดตาม',
  },
]

export default function FollowUps() {
  return (
    <Page>
      <PageHeader title="ติดตาม" subtitle="ติดตามคนไข้และงานที่ต้องดำเนินการ" />

      <div className="grid gap-4 sm:grid-cols-2">
        {TOOLS.map(({ to, icon: Icon, title, desc }) => (
          <Link
            key={to}
            to={to}
            className="group rounded-2xl border border-slate-200 bg-white p-5 shadow-sm hover:border-brand-300 hover:shadow-md transition flex items-start gap-4"
          >
            <div className="w-11 h-11 rounded-xl bg-brand-50 text-brand-600 flex items-center justify-center shrink-0">
              <Icon size={22} strokeWidth={1.75} />
            </div>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-1 text-[15.5px] font-semibold text-slate-900">
                {title}
                <ChevronRight size={16} className="text-slate-300 group-hover:text-brand-400 transition" />
              </div>
              <p className="text-[13px] text-slate-500 mt-1 leading-relaxed">{desc}</p>
            </div>
          </Link>
        ))}
      </div>
    </Page>
  )
}
